import { render, staticRenderFns } from "./about.vue?vue&type=template&id=65783f85&scoped=true&"
import script from "./about.js?vue&type=script&lang=js&"
export * from "./about.js?vue&type=script&lang=js&"
import style0 from "./about.css?vue&type=style&index=0&id=65783f85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65783f85",
  null
  
)

export default component.exports